<template>
    <header v-on:click.stop :class="{compact : type === 'compact'}">
        <div class="bohemia-header-nav-left">
            <ToggleNav @toggle="toggleNav" :active="navigationOpen"/>
        </div>

        <h1 id="bohemia-header-logo-wrapper">
            <Logo :compact="type === 'compact'"/>
        </h1>

        <Navigation v-if="navigation.left"
                    class="bohemia-header-nav"
                    :class="{'open' : navigationOpen}"
                    :items="navigation.left"
                    :active="active"
                    :open="open"
                    @onOpen="changeOpenDropdown"/>

        <aside class="bohemia-header-nav bohemia-header-nav-right">
            <ul class="bohemia-header-nav-items">
                <li v-if="navigation.right" class="bohemia-header-nav-item" v-for="item in navigation.right">
                    <a class="bohemia-header-nav-item-button" :href="item.href"><span>{{item.name}}</span></a>
                </li>
                <Account v-if="withLogin"
                         :avatar="avatar"
                         :registerPath="registerPath"
                         :loginPath="loginPath"
                         :logoutPath="logoutPath"
                         :authBaseUrl="authBaseUrl"
                         :user="user"
                         :gravatarUrl="gravatarUrl"
                         :avatarUrl="avatarUrl"
                         :open="open"
                         @onOpen="changeOpenDropdown"/>
            </ul>
        </aside>
    </header>
</template>

<script>
    import navigationData from './../../config/header/nav';
    import Account from './partials/Account';
    import Dropdown from './partials/Dropdown';
    import ToggleNav from './partials/Toggle';
    import Navigation from './partials/Navigation';
    import Logo from './partials/Logo';

    export default {
        name      : 'bohemia-header',
        components: {Dropdown, Account, ToggleNav, Navigation, Logo},
        props     : {
            type        : {
                type   : String,
                default: 'full',
            },
            active      : String,
            gravatarUrl : String,
            avatarUrl   : String,
            avatar      : {
                type   : String,
                default: 'gravatar',
            },
            withLogin   : {
                type   : Boolean,
                default: true
            },
            userData    : {
                type   : Object,
                default: function() {
                    return {}
                }
            },
            authBaseUrl : {
                type   : String,
                default: '/api/'
            },
            registerPath: String,
            loginPath   : String,
            logoutPath  : String,
        },
        data      : function() {
            return {
                open          : null,
                user          : this.userData,
                navigationOpen: false,
            }
        },
        watch     : {
            userData: function(value) {
                this.user = value;
            }
        },
        computed  : {
            navigation: function() {
                return navigationData[this.type];
            }
        },
        methods   : {
            toggleNav() {
                this.navigationOpen = !this.navigationOpen;
            },
            changeOpenDropdown(id) {
                this.open = id
            },
            closeMenusnOnClick() {
                if (this.open) {
                    this.open = null
                }

                if (this.navigationOpen) {
                    this.navigationOpen = false
                }
            },
        },
        created   : function() {
            window.addEventListener('bohemiaHeaderUpdateUser', evt => {
                this.user = evt.detail.user;
            });
        },
        mounted   : function() {
            document.addEventListener('click', this.closeMenusnOnClick);
        },
    }
</script>

<style lang="scss">
    @import '/../../assets/scss/breakpoints';

    #bohemia-header {
        height: auto !important;

        h1, h2, h3 {
            border: 0;
            padding: 0;
            margin: 0;
        }

        h1, h2, h3, p, a, span {
            font-family: 'Palanquin Dark', sans-serif;
        }

        * {
            box-sizing: border-box;
            font-family: 'Palanquin Dark', sans-serif;
        }

        ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }
    }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Palanquin+Dark" rel="stylesheet');
    @import '/../../assets/scss/header/colors';
    @import '/../../assets/scss/header/nav';
    @import '/../../assets/scss/breakpoints';
    @import '/../../assets/scss/header/vars';
    @import "~sanitize.css";

    header {
        width: 100%;
        min-width: 320px;
        background: $bg;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 50px;
        font-size: 14px;
        font-family: 'Palanquin Dark', sans-serif;
        line-height: 80px;
        height: 80px;
        box-sizing: border-box;
        transition: padding .5s, line-height .5s;
        vertical-align: initial;
        position: relative;
        z-index: 3000;

        @media (max-width: $brMedium) {
            padding: 0 15px;
            line-height: 50px;
            height: 50px;
        }

        .hide-on-medium {
            @media (max-width: $brMedium) {
                display: none;
            }
        }

        .show-on-medium {
            @media (min-width: $brMedium) {
                display: none;
            }
        }

        &.compact {
            line-height: 50px;
        }
    }

    #bohemia-header-logo-wrapper {
        margin: 0;
        padding: 0;
        font-size: 0;
        width: 150px;
        text-align: left;

        @media (max-width: $brMedium) {
            text-align: center;
        }
    }

    .bohemia-header-nav {
        display: flex;
    }

    .bohemia-header-nav-left, .bohemia-header-nav-right {
        width: 150px;
    }

    .bohemia-header-nav-right {
        display: flex;
        justify-content: flex-end;
    }

    .bohemia-header-nav-left {
        display: none;
        flex-direction: row;

        @media (max-width: $brMedium) {
            display: flex;
        }
    }
</style>
